module.exports = __webpack_public_path__ + "static/media/bg-1.0066b33c.png";